import $ from "jquery";

/*
 * Pins a daterangepicker popup directly below its filter card, at the
 * card's exact width. Replaces the plugin's own move() so window resizes
 * and scrolling of the mobile content area keep it aligned.
 * Optional widthEl aligns the popup to a wider filter row for compact buttons.
 * Returns a cleanup function.
 */
export const alignPickerToFilter = (picker, filterEl, widthEl = filterEl) => {
  const GAP = 6;

  picker.move = function () {
    const rect = filterEl.getBoundingClientRect();
    const widthRect = widthEl.getBoundingClientRect();

    this.container.css({
      position: "fixed",
      top: `${rect.bottom + GAP}px`,
      left: `${widthRect.left}px`,
      right: "auto",
      transform: "none",
      width: `${widthRect.width}px`,
    });
  };

  const $scroller = $(filterEl).closest(".mobile-layout-content");
  const $filter = $(filterEl);
  const backdrop = document.createElement("div");
  backdrop.className = "mobile-daterangepicker-backdrop";
  backdrop.setAttribute("aria-hidden", "true");

  const showBackdrop = () => document.body.appendChild(backdrop);
  const hideBackdrop = () => backdrop.remove();
  const dismissPicker = () => picker.hide();

  backdrop.addEventListener("click", dismissPicker);
  $filter.on("show.daterangepicker.mobilePickerBackdrop", showBackdrop);
  $filter.on("hide.daterangepicker.mobilePickerBackdrop", hideBackdrop);

  const handleScroll = () => {
    if (picker.isShowing) picker.move();
  };

  $scroller.on("scroll.mobilePicker", handleScroll);

  return () => {
    $scroller.off("scroll.mobilePicker", handleScroll);
    $filter.off(".mobilePickerBackdrop");
    backdrop.removeEventListener("click", dismissPicker);
    hideBackdrop();
  };
};
